export enum RoutesEnum {
  ROOT = "/",
  HOME = "/home",
  CREATE = "/create",
  LINKS = "/links",
  LOGIN = "/login",
}
